/**
 * Swaps an id with a new id in an object.
 * 
 * The original object is deeply cloned and not mutated.
 *
 * @param {Object} obj - The object to process.
 * @param {string} oldId - The id to replace.
 * @param {string} newId - The new id to use.
 * @returns {Object|Array} - The updated schema with the id swapped.
 */
export function swapId(obj, oldId, newId) {

  if (!obj || typeof obj !== 'object' || !obj[oldId]) return obj;

  const clonedObj = JSON.parse(JSON.stringify(obj));

  clonedObj[newId] = clonedObj[oldId];
  delete clonedObj[oldId];

  return clonedObj;
}